import { render, staticRenderFns } from "./McaPreviewOnlineReportPDF.vue?vue&type=template&id=71c89195&scoped=true"
import script from "./McaPreviewOnlineReportPDF.vue?vue&type=script&lang=ts"
export * from "./McaPreviewOnlineReportPDF.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c89195",
  null
  
)

export default component.exports